
  <div class="b-page-section__wrapper">
    <header>
      <ng-template #titleContent>
        <button type="button" class="b-heading-toggle" [attr.aria-expanded]="!collapsed" (click)="toggleCollapsed()">
          <span [innerHTML]="title"></span>
          <ng-content select="f-facet[name=title],[facet-title]"></ng-content>
          <span class="b-icon b-icon--hinge-fold-out" aria-hidden="true">{{toggleMatIcon}}</span>
        </button>
      </ng-template>
      @switch (level) {
        @case (1) { <h1 class="b-page-section__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h1> }
        @case (3) { <h3 class="b-page-section__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h3> }
        @case (4) { <h4 class="b-page-section__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h4> }
        @case (5) { <h5 class="b-page-section__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h5> }
        @case (6) { <h6 class="b-page-section__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h6> }
        @default { <h2 class="b-page-section__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h2> }
      }
    </header>

    <div *ngIf="!collapsed" class="b-page-section__content">
      <div hide-empty class="b-page-section__info" >
        <ng-content select="f-facet[name=info],[facet-info]"></ng-content>
      </div>

      <div class="b-page-section__header-actions">
        <ng-content select="f-facet[name=header-actions],[facet-header-actions]"></ng-content>
      </div>

      <ng-content></ng-content>

      <div class="b-page-section__footer-actions">
        <ng-content select="f-facet[name=footer-actions],[facet-footer-actions]"></ng-content>
      </div>
    </div>
  </div>

